import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { RecurrenceSubscriptionDTO } from "src/app/data/schema/Billing/RecurrenceSubscription/RecurrenceSubscriptionDTO";
import { ApiBillingRecurrenceSubscriptionService } from "src/app/data/service/billing/api-billing-recurrence-subscription.service";

@Component({
    selector: "app-cancel-recurrence-subscription",
    templateUrl: "./cancel-recurrence-subscription.component.html",
    styleUrls: ["./cancel-recurrence-subscription.component.scss"]
})
export class CancelRecurrenceSubscriptionComponent implements OnInit, OnDestroy {
    cancelBillForm: UntypedFormGroup;
    comments: string;
    isLoading: boolean;

    private _unsubscribeAll: Subject<any>;

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _apiBillingBillsService: ApiBillingRecurrenceSubscriptionService,
        private dialogRef: MatDialogRef<CancelRecurrenceSubscriptionComponent>,
        private _translateService: TranslateService,
        private _snackbarService: SnackbarService,
        @Inject(MAT_DIALOG_DATA) public data: { bill: RecurrenceSubscriptionDTO }
    ) {
        this.comments = "";
        this.isLoading = false;

        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.cancelBillForm = this.createCancelBillForm();
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    createCancelBillForm(): UntypedFormGroup {
        return this._formBuilder.group({
            comments: ["", Validators.compose([Validators.required, Validators.maxLength(100)])]
        });
    }

    cancelBillClick(): void {
        this.isLoading = true;

        this._apiBillingBillsService
            .cancel(this.data.bill.id, this.comments)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                () => {
                    this._translateService
                        .get("RECURRENCE_SUBSCRIPTION.CANCEL.SUCCESS_MESSAGE")
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((res) => {
                            this._snackbarService.showMessage(res);
                        });
                    this.dialogRef.close(true);
                },
                (error) => {
                    this.isLoading = false;
                    this._translateService
                        .get("RECURRENCE_SUBSCRIPTION.CANCEL.ERROR_MESSAGE")
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((res) => {
                            this._snackbarService.showMessage(res);
                        });
                    console.log(error);
                },
                () => {
                    this.isLoading = false;
                }
            );
    }

    public close(): void {
        this.dialogRef.close(false);
    }
}
